import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { refreshInsuranceApplication } from '@/models/insuranceApplication'

/** Carriers were asked: the quotes route reads the application, so it has to see that before it opens. */
export function GoToQuotes({ applicationId }: { applicationId: string | undefined }) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  useEffect(() => {
    const go = () => void navigate('/quotes', { replace: true })
    if (!applicationId) return go()
    refreshInsuranceApplication(queryClient, applicationId).then(go, go)
  }, [applicationId, navigate, queryClient])

  return <SkeletonRows className="mt-10" rows={6} rowClassName="h-16" />
}
